import { createSlice } from "@reduxjs/toolkit";

export const StepperSlice = createSlice({
  name: "Stepper",
  initialState: {
    labels: [],
    step: 0,
  },
  reducers: {
    increaseStep: (state) => {
      state.step += 1;
    },
    decreaseStep: (state) => {
      state.step -= 1;
    },
    setStep: (state, { payload }) => {
      state.step = payload;
    },
    setLabels: (state, { payload }) => {
      state.labels = payload;
    },
  },
});

export const { increaseStep, decreaseStep, setStep, setLabels } = StepperSlice.actions;

export const StepperReducer = StepperSlice.reducer;
